import { Component, OnInit } from '@angular/core';
import { ConnectivityService } from '@app/services/connectivity.service';

@Component({
  selector: 'app-offline-screen',
  templateUrl: './offline-screen.component.html',
  styleUrl: './offline-screen.component.scss'
})
export class OfflineScreenComponent implements OnInit {
  
  constructor(private connectivityService: ConnectivityService) { }

  ngOnInit(): void {
  }

  retry() {
    // Force check
    if (navigator.onLine) {
      window.location.reload();
    }
  }
}
